import { LoadingModal } from "../LoadingModal";
import Modal, { ModalButton, ModalSecondaryButton } from "../Modal";
import { Descriptions } from "./styles";

type Props = {
  type?: "DANGER" | "INFO" | "WHITE";
  title: string;
  descriptions?: string[];
  confirmButtonTitle?: string;
  cancelTitle?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
  onExit?: () => void;
  outsideExit?: boolean;
  confirming?: boolean;
  /** A Keepo Plus offer: green glow and a green main button */
  tone?: "plus";
};

/**
 * Asks to confirm an action (or tells something, with only the main button): the title in the header, the
 * descriptions in the body, Cancel and the main action in the footer. The X and Cancel close it the same way.
 */
const ConfirmModal = ({
  type,
  title,
  descriptions = [],
  confirmButtonTitle,
  cancelTitle,
  onConfirm,
  onCancel,
  onExit,
  outsideExit = true,
  confirming,
  tone,
}: Props) => {
  const close = onExit || onCancel;
  const cancel = onCancel || onExit;
  const hasConfirm = !!confirmButtonTitle && !!type;
  const hasCancel = !!cancelTitle && !!cancel;

  return confirming ? (
    <LoadingModal />
  ) : (
    <Modal
      size="sm"
      tone={tone}
      title={title}
      outsideExit={outsideExit && !!close}
      onExit={close}
      hideExitButton={!close}
      footer={
        (hasConfirm || hasCancel) && (
          <>
            {hasCancel && (
              <ModalSecondaryButton type="button" onClick={cancel}>
                {cancelTitle}
              </ModalSecondaryButton>
            )}
            {hasConfirm && (
              <ModalButton variant={tone === "plus" ? "plus" : type} onClick={onConfirm}>
                {confirmButtonTitle}
              </ModalButton>
            )}
          </>
        )
      }>
      {descriptions.length > 0 && (
        <Descriptions>
          {descriptions.map((description, index) => (
            <p key={index}>{description}</p>
          ))}
        </Descriptions>
      )}
    </Modal>
  );
};

export default ConfirmModal;
